import type { FC } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { Card, CardContent, Typography, Divider, Grid, Box } from '@packages/shared';

import { SearchField } from '@packages/modules/src/Header/Toolbar/SearchField/SearchField';

const allMessages = defineMessages({
  headline: {
    id: 'searchTips.headline',
    defaultMessage: 'Tipps zur weiteren Suche',
  },
  searchTips: {
    id: 'searchTips.bulletPoints',
    defaultMessage:
      'Überprüfe deinen Suchbegriff auf Tippfehler.<br>Verwende einen allgemeineren Suchbegriff.<br>Versuche eine Suche mit weniger Wörtern.<br>Umschreibe deinen gesuchten Artikel mit einem anderen Begriff (Synonym).',
  },
});

/**
 * Provides a search with tips section for the search result page if no results are available
 * */
export const SearchTipsSection: FC = () => {
  const { formatMessage } = useIntl();
  return (
    <Card data-testid="search-tips-section">
      <CardContent>
        <Typography variant="h5" sx={{ marginBottom: 1 }}>
          <FormattedMessage {...allMessages.headline} />
        </Typography>
        <Divider sx={{ mx: -2 }} />
        <Grid container spacing={2} sx={{ marginTop: 1 }}>
          <Grid item xs={12} md={6} lg={4}>
            <SearchField isolated />
          </Grid>
          <Grid item xs={12} md lg>
            <Box
              sx={{
                minHeight: '6.25rem',
                marginLeft: {
                  xs: 2,
                  md: 4,
                },
              }}
            >
              {formatMessage(allMessages.searchTips)
                .split('<br>')
                .map((message, index) => (
                  <Typography
                    role="listitem"
                    key={index} /* eslint-disable-line react/no-array-index-key */
                    variant="body2"
                    sx={{ display: 'list-item', lineHeight: 1.5 }}
                  >
                    {message}
                  </Typography>
                ))}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
